import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Backdrop, Dialog, LinearProgress } from '@mui/material';
import {
  IDispatchProps,
  IProps,
} from './interfaces';
import { disableClipperKeyboardControls } from '../../state/videoPlayer';
import { BlackoutContainer, DialogContentContainer } from './styles';
import { getAsset } from '../../../../api/vault/assets';
import { IAppState } from '../../../../state/reducers';
import { StreamStatus } from '../../../../enums';
import { DialogHeader, DialogHeaderTitle } from '../../../Shared/styles/dialog';

const REFRESH_INTERVAL = 10000;
const CONTAINER_ID = 'videoProcessing';

const VideoProcessingDialog: React.FC<IProps> = (props: IProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { disableClipperKeyboardControlsConnect, assetId } = props;

  useEffect(() => {
    const handleVideoProcessing = async () => {
      if (!assetId) return;
      const asset = (await getAsset(assetId))?.data?.data;
      if (asset?.streamStatus === StreamStatus.Processing && !isOpen) {
        setIsOpen(true);
        disableClipperKeyboardControlsConnect();
      } else if (asset?.streamStatus === StreamStatus.Complete && isOpen) {
        setIsOpen(false);
        window.location.reload();
      }
    };
    handleVideoProcessing();
    const statusCheck = setInterval(handleVideoProcessing, REFRESH_INTERVAL);
    return () => {
      try {
        clearInterval(statusCheck);
      } catch (e) {
        // Do nothing
      }
    };
  }, [isOpen, assetId]);

  if (!isOpen) return null;
  return (
    <BlackoutContainer id={CONTAINER_ID}>
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth="sm"
        container={() => document.getElementById(CONTAINER_ID)}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            sx: {
              top: '64px',
            },
          },
        }}
      >
        <DialogHeader>
          <DialogHeaderTitle style={{ marginLeft: '12px' }}>
            Live Stream Processing
          </DialogHeaderTitle>
        </DialogHeader>
        <LinearProgress />
        <DialogContentContainer>
          <p>This Live Stream has ended and is being processed. Live Clipping will be temporarily unavailable until processing is complete.</p>
          {/* <br />
          <p>To check the status of this Live Stream, please check back here or visit the Jobs page.</p> */}
        </DialogContentContainer>

      </Dialog>
    </BlackoutContainer>
  );
};

const mapDispatchToProps: IDispatchProps = {
  disableClipperKeyboardControlsConnect: disableClipperKeyboardControls,
};

const mapStateToProps = (state: IAppState) => ({
  assetId: state.clipperMediaContent.assetId,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VideoProcessingDialog);
